export default __webpack_public_path__ + "36205341be7a2f68e49bffe353ebd830.webp";